// Angular
import { Component, inject, OnInit, signal } from '@angular/core';
import { NgClass } from '@angular/common';

// Angular Material / CDK
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Constants
import { Confirmation } from '@constants/enum';
import { environment } from '@env';

@Component({
  templateUrl: './countdown-dialog.component.html',
  styleUrl: './countdown-dialog.component.scss',
  imports: [MatButtonModule, NgClass],
})
export class CountdownDialogComponent implements OnInit {
  public dialog = inject(MatDialogRef<CountdownDialogComponent>);
  private data = inject(MAT_DIALOG_DATA) as {
    type: string;
  };

  readonly type = signal(this.data.type);
  readonly startCount = signal(environment.clickPreventionTimer);
  readonly editEnabled = signal(false);
  readonly confirmation = Confirmation;

  constructor() {
    this.dialog.disableClose = true;
  }

  ngOnInit() {
    const interval = setInterval(() => {
      this.startCount.update((count) => count - 1);

      if (this.startCount() === 0) {
        this.editEnabled.set(true);
        clearInterval(interval);
      }
    }, 1000);
  }
}
